export default {
  paper: {
    banner: '论文',
    title: 'PWmat 相关文献',
    titleP1: '下面的表格中我们列出了和PWmat相关的文献供用户研究参考：',
    year: '年',
  }
}